/**
 * Injects Authorization token and baseApiUrl into HttpClient api calls.
 */
import { Inject, Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from "@angular/common/http";
import { PnpClientService } from "../services/pnp-client.service";
import { from, Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { configToken, PnpConfig } from "../interfaces/pnp-config";
import { COMMON_CONSTANTS } from "src/app/common/core/common.constants";
@Injectable({
  providedIn: "root",
})
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private _pnpClient: PnpClientService,
    @Inject(configToken) private _pnpConfig: PnpConfig
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this._pnpClient.isRunningInGlobalNav()) {
      return next.handle(req);
    }

    let _req = req.clone();
    if (!_req.url.startsWith(this._pnpConfig.xhrPrefix)) {
      _req = _req.clone({
        url: `${this._pnpConfig.xhrPrefix}${_req.url}`,
      });
    }
    if (_req.headers.get("skip")) {
      _req = _req.clone({
        headers: _req.headers.delete("skip"),
      });
    }
    if (!this._pnpConfig.shouldInjectToken) {
      return next.handle(_req);
    }

    const token$ =
      this._pnpClient.idpType === "iam" || "azure"
        ? this._pnpClient.getIdToken()     // use idToken for iam flow
        : this._pnpClient.getAccessToken();

        return from(token$).pipe(
          switchMap((token) => {
            if (req.url.includes(COMMON_CONSTANTS.TOKENS_V6)) {
              return next.handle(_req);
            } else {
              if (this._pnpClient.idpType !== "iam" && this._pnpClient.idpType !== "azure") {
                return next.handle(
                  _req.clone({
                    setHeaders: { authtoken: JSON.parse(localStorage.getItem('GLOBAL_NAV_OKTA_STORAGE'))["idToken"]["value"] },
                  })
                );
              }
              return next.handle(
                _req.clone({
                  setHeaders: { authtoken: token },
                })
              );
             }
          })
        );
  }
}
